export const LINKS = [
  { label: "linkedin", href: "https://www.linkedin.com/in/spandansshrestha/" },
  { label: "github", href: "https://github.com/SPANDANS04" },
];

// `~/projects` stays out of the nav while the projects section is stashed.
// shortLabel drops the `~/` prefix: the four full labels do not fit inside the
// mobile pill nav on a 375px-wide phone, let alone a 320px one.
export const NAV_ITEMS = [
  { id: "quick-links", label: "~/welcome", shortLabel: "welcome" },
  { id: "introduction", label: "~/introduction", shortLabel: "intro" },
  { id: "skills", label: "~/skills", shortLabel: "skills" },
  { id: "contact", label: "~/contact", shortLabel: "contact" },
];

export const INTRO_LINES = [
  { pre: "Always ", hl: "learning", post: "." },
  { pre: "", hl: "Love", post: " tech." },
  { pre: "Social.", hl: "", post: "" },
  { pre: "Real.", hl: "", post: "" },
];

export const SKILL_GROUPS = [
  {
    name: "technical",
    cmd: "tree technical",
    items: [
      "Arch BTW",
      "Python",
      "C++, Lua, XML",
      "Java & C# backends",
      "Building applications with REST APIs",
      "SQL (solid level)",
      "Linux ",
      "Networking & homelab infrastructure",
      "Self-hosting & server administration",
      "Cybersecurity fundamentals",
      "Web scraping & automation",
      "Git & version control",
    ],
  },
  {
    name: "non_technical",
    cmd: "tree non_technical",
    items: [
      "Problem solving",
      "Self-teaching new tech fast",
      "Communication",
      "Collaboration",
      "Documentation & writing",
      "Languages: EN / NL / NE",
      "Patience for debugging",
      "Puzzle games: sudoku, minesweeper, rubik's cubes",
    ],
  },
  {
    name: "near_future",
    cmd: "tree near_future",
    items: [
      "Learn Spanish",
      "Learn to play piano",
      "Learn more about hardware",
      "Hardware/software interaction",
      "Interested in AI & ML",
    ],
  },
];

export const LS_ROWS = [
  { perms: "-rw-r--r--", owner: "email", bytes: "28", date: "Feb 14 09:42", name: "spandan@shrestha.love", href: "mailto:spandan@shrestha.love" },
  { perms: "-rw-r--r--", owner: "phone", bytes: "16", date: "Jan 03 21:07", name: "+32 489 76 75 50", href: "tel:+32489767550" },
  { perms: "-rwxr-xr-x", owner: "linkedin", bytes: "42", date: "Mar 22 14:18", name: "in/spandansshrestha", href: "https://www.linkedin.com/in/spandansshrestha/" },
  { perms: "-rwxr-xr-x", owner: "github", bytes: "31", date: "Jun 17 11:53", name: "SPANDANS04", href: "https://github.com/SPANDANS04" },
  { perms: "-rwxr-xr-x", owner: "instagram", bytes: "37", date: "Nov 08 02:31", name: "@spandan.sth4", href: "https://www.instagram.com/spandan.sth4/" },
];

// Stashed with the projects section — kept for when it comes back.
export const PROJECTS = [
  {
    title: "YouTube Converter",
    desc: "Convert YouTube videos to MP3 or MP4 directly in the browser.",
    href: "/converter",
    tag: "Try it →",
  },
  {
    title: "Image Webscraper",
    desc: "Python tool that scrapes and downloads images from the web.",
    href: null as string | null,
    tag: "Python",
  },
  {
    title: "Homelabbing",
    desc: "Self-hosted services, networking, and infrastructure experiments at home.",
    href: null as string | null,
    tag: "Ongoing",
  },
  {
    title: "Learning C++ & Lua",
    desc: "Building small projects to get comfortable with lower-level programming.",
    href: null as string | null,
    tag: "In progress",
  },
  {
    title: "More on the way",
    desc: "A few more projects in the works. You'll hear about them when the time is right :)",
    href: null as string | null,
    tag: "Soon",
  },
];
